import type { SupportedFeature, FeatureFlag, HasSupportedFeatures } from "@/App/types/twiageTypes";

export const hasSupportedFeature = ({
  organization,
  feature,
}: {
  organization: HasSupportedFeatures | undefined;
  feature: FeatureFlag;
}): boolean => {
  return supportedFeatures({ organization, feature }).length > 0;
};

const supportedFeatures = ({
  organization,
  feature,
}: {
  organization: HasSupportedFeatures | undefined;
  feature: FeatureFlag;
}): SupportedFeature[] => {
  return organization?.supportedFeatures?.filter((item) => item.name === feature && item.enabled) ?? [];
};
